import React, { useState } from "react";
import { FaMicrophone } from "react-icons/fa";
import backgroundImage from "../../../assets/identitymodulenbg.jpeg";
import { useNavigate } from "react-router-dom";

const sections = [
  "Title",
  "Value",
  "Indicators",
  "Traits",
  "Situation & Behaviors",
  "Your Space",
  "Final Card",
];

const IdCardForm = () => {
  const [formData, setFormData] = useState({
    profileImage: "",
    title: "",
  });
  const [preview, setPreview] = useState(null);
  const [currentSection, setCurrentSection] = useState(0);
  const [showCustomValueInput, setShowCustomValueInput] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [customValue, setCustomValue] = useState("");
  const [indicators, setIndicators] = useState([]);
  const [newIndicator, setNewIndicator] = useState("");
  const [situations, setSituations] = useState(["Situation 1"]);
  const [selectedTraits, setSelectedTraits] = useState([]);
  const [customTraits, setCustomTraits] = useState("");

  const navigate = useNavigate();

  // const handleNext = () => {
  //   if (currentSection < sections.length - 1) {
  //     setCurrentSection(currentSection + 1);
  //   } else {
  //     navigate("/final-id-card");
  //   }
  // };

  const predefinedValues = [
    "Integrity",
    "Leadership",
    "Empathy",
    "Communication",
    "Innovation",
    "Adaptability",
    "Accountability",
    "Creative",
  ];

  const predefinedTraits = [
    "Achievment",
    "Balance",
    "Ethics",
    "Team Work",
    "Helping",
    "Creative",
    "Personal growth",
  ];

  const handleAddIndicator = () => {
    if (newIndicator.trim() !== "" && indicators.length < 4) {
      setIndicators([...indicators, newIndicator.trim()]);
      setNewIndicator("");
    }
  };

  const handleRemoveIndicator = (index) => {
    setIndicators(indicators.filter((_, i) => i !== index));
  };

  const handleValueSelection = (value) => {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter((v) => v !== value));
    } else if (selectedValues.length < 3) {
      setSelectedValues([...selectedValues, value]);
    }
  };

  const handleAddCustomValue = () => {
    if (customValue.trim() !== "" && selectedValues.length < 3) {
      setSelectedValues([...selectedValues, customValue.trim()]);
      setCustomValue("");
    }
  };

  const addSituation = () => {
    if (situations.length < 4) {
      setSituations([...situations, `Situation ${situations.length + 1}`]);
    }
  };

  const handleTraitsSelection = (value) => {
    if (selectedTraits.includes(value)) {
      setSelectedTraits(selectedTraits.filter((v) => v !== value));
    } else if (selectedTraits.length < 3) {
      setSelectedTraits([...selectedTraits, value]);
    }
  };

  const handleAddCustomTraits = () => {
    if (customTraits.trim() !== "" && selectedTraits.length < 3) {
      setSelectedTraits([...selectedTraits, customTraits.trim()]);
      setCustomTraits("");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, profileImage: file });
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const renderSection = () => {
    switch (currentSection) {
      case 0:
        return (
          <div className="bg-white border border-gray-700 shadow-lg rounded-xl p-4 w-[60%]">
            <div className="border-2 border-dashed border-gray-400 rounded-md w-full h-40 flex flex-col items-center justify-center cursor-pointer">
              <input
                type="file"
                accept="image/*"
                className="hidden"
                id="fileUpload"
                onChange={handleImageUpload}
              />
              <label htmlFor="fileUpload" className="cursor-pointer">
                {preview ? (
                  <img
                    src={preview}
                    alt="Profile Preview"
                    className="w-full h-full object-cover rounded-md"
                  />
                ) : (
                  <span className="text-gray-400">
                    + Upload Photo under 10MB
                  </span>
                )}
              </label>
            </div>
            <div className="mt-20">
              <h3 className="text-3xl font-medium">I want to be</h3>
              <input
                type="text"
                placeholder="Type here"
                className="w-full outline-none mt-4 text-sm text-7ra font-semibold text-centery-706"
              />
              <p className="text-xs text-gray-400 mt-3">
                Give a title or one-line description in less than 30 characters.
              </p>
            </div>
            <button className="w-full py-2 mt-48 border border-gray-500 rounded-md hover:bg-gray-200">
              Save
            </button>
          </div>
        );

      case 1:
        return (
          <div className="bg-white border border-gray-700 shadow-lg rounded-xl p-6 w-[60%]">
            <h3 className="text-2xl font-semibold text-gray-700">
              Choose Values as your future self
            </h3>
            <p className="text-sm text-gray-700 mt-4">
              Values are basic and fundamental beliefs that guide or motivate
              attitudes or actions.
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Select up to <b>3 values</b>
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {predefinedValues.map((value) => (
                <button
                  key={value}
                  className={`px-4 py-1 rounded-md border ${
                    selectedValues.includes(value)
                      ? "bg-orange-400 text-white border-orange-400"
                      : "border-gray-400 text-gray-600 hover:bg-gray-200"
                  }`}
                  onClick={() => handleValueSelection(value)}
                >
                  {value}
                </button>
              ))}
            </div>
            <button
              className="mt-4 px-4 py-1 border border-gray-400 rounded-lg text-gray-600 hover:bg-gray-200"
              onClick={() => setShowCustomValueInput(true)}
            >
              + Add Custom Values
            </button>
            {showCustomValueInput && (
              <div className="flex gap-2 mt-4">
                <input
                  type="text"
                  placeholder="Type custom value"
                  className="w-full outline-none text-sm text-gray-900 placeholder:text-gray-600 font-semibold text-center px-6 py-1"
                  value={customValue}
                  onChange={(e) => setCustomValue(e.target.value)}
                />
                <button
                  className="px-4 py-1 bg-orange-400 text-white rounded-md disabled:bg-gray-300"
                  onClick={handleAddCustomValue}
                  disabled={
                    customValue.trim() === "" || selectedValues.length >= 3
                  }
                >
                  Add
                </button>
              </div>
            )}
            <button className="w-full py-2 mt-56 border border-gray-500 rounded-md hover:bg-gray-200">
              Save
            </button>
          </div>
        );

      case 2:
        return (
          <div className="bg-white border border-gray-700 shadow-lg rounded-xl p-6 w-[60%]">
            <h3 className="text-2xl font-semibold text-gray-700">
              How will you know that you have become the
            </h3>
            <p className="text-sm text-gray-500 mt-4">
              Type your top 4 indicators. How will you know that you have
              reached your goal?
            </p>
            <div className="mt-6 space-y-2">
              {indicators.map((indicator, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center bg-gray-100 px-3 py-2 rounded-md"
                >
                  <span className="text-gray-700 text-sm">{indicator}</span>
                  <button
                    className="text-gray-600 hover:text-red-500"
                    onClick={() => handleRemoveIndicator(index)}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
            {indicators.length < 4 && (
              <div className="mt-24 flex gap-2">
                <input
                  type="text"
                  placeholder="Type in your goals"
                  className="w-full outline-none text-sm text-gray-900 placeholder:text-gray-600 font-semibold text-center px-6 py-1"
                  value={newIndicator}
                  onChange={(e) => setNewIndicator(e.target.value)}
                />
                <button
                  className="px-4 py-1 bg-orange-400 text-white rounded-md disabled:bg-gray-300"
                  onClick={handleAddIndicator}
                  disabled={newIndicator.trim() === ""}
                >
                  Add
                </button>
              </div>
            )}
            <button className="w-full py-2 mt-72 border border-gray-500 rounded-md hover:bg-gray-200">
              Save
            </button>
          </div>
        );

      case 3:
        return (
          <div className="bg-white border border-gray-700 shadow-lg rounded-xl p-6 w-[60%]">
            <h3 className="text-2xl font-semibold text-gray-700">
              Choose Values as your future self
            </h3>
            <p className="text-sm text-gray-700 mt-4">
              Values are basic and fundamental beliefs that guide or motivate
              attitudes or actions.
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Select up to <b>3 values</b>
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {predefinedTraits.map((value) => (
                <button
                  key={value}
                  className={`px-4 py-1 rounded-md border font-semibold ${
                    selectedValues.includes(value)
                      ? "bg-green-400 text-white border-green-400"
                      : "border-gray-400 text-gray-600 hover:bg-gray-200"
                  }`}
                  onClick={() => handleTraitsSelection(value)}
                >
                  {value}
                </button>
              ))}
            </div>
            <button
              className="mt-2 px-4 py-1 font-semibold border border-gray-400 rounded-lg text-gray-600 hover:bg-gray-200"
              onClick={() => setShowCustomValueInput(true)}
            >
              + Add Custom Values
            </button>
            {showCustomValueInput && (
              <div className="flex gap-2 mt-4">
                <input
                  type="text"
                  placeholder="Type custom value"
                  className="w-full outline-none text-sm text-gray-900 placeholder:text-gray-600 font-semibold text-center px-6 py-1"
                  value={customValue}
                  onChange={(e) => setCustomValue(e.target.value)}
                />
                <button
                  className="px-4 py-1 bg-orange-400 text-white rounded-md disabled:bg-gray-300"
                  onClick={handleAddCustomTraits}
                  disabled={
                    customValue.trim() === "" || selectedValues.length >= 3
                  }
                >
                  Add
                </button>
              </div>
            )}
            <button className="w-full py-2 mt-56 border border-gray-500 rounded-md hover:bg-gray-200">
              Save
            </button>
          </div>
        );

      case 4:
        return (
          <div className="bg-white border border-gray-700 shadow-lg rounded-xl p-4 w-[60%]">
            <h2 className="text-xl font-semibold">
              My Situation and Behaviors as a CTO
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              What are some critical situations you might face as a CTO, and how
              would you handle them? You can describe up to 4 scenarios, but
              provide at least two.
            </p>
            <div className="mt-4 flex">
              {situations.map((situation, index) => (
                <button
                  key={index}
                  className="px-2 h-8 bg-orange-400 text-white rounded-t-xl font-medium"
                >
                  {situation}
                </button>
              ))}
              {situations.length < 4 && (
                <button
                  onClick={addSituation}
                  className="px-4 h-8 border border-gray-400 rounded-t-xl text-gray-600 hover:bg-gray-100"
                >
                  + Add
                </button>
              )}
            </div>
            <div className="border border-gray-300 rounded-b-md p-4">
              <input
                type="text"
                placeholder="Add a Title for a Situation"
                className="w-full outline-none text-sm text-gray-900 placeholder:text-gray-600 font-semibold text-center pb-8"
              />
              <textarea
                placeholder="Write a short Description under 50 words"
                className="w-full outline-none text-sm text-gray-900 placeholder:text-gray-600 font-semibold text-center mt-8 pb-8"
                rows="3"
              ></textarea>
              <textarea
                placeholder="Write how would you behave in that situation under 50 words"
                className="w-full outline-none text-sm text-gray-900 placeholder:text-gray-600 font-semibold text-center mt-8 pb-8"
                rows="4"
              ></textarea>
            </div>
            <button className="w-full py-2 mt-12 border border-gray-500 rounded-md hover:bg-gray-200">
              Save
            </button>
          </div>
        );

      case 5:
        return (
          <div className="bg-white border border-gray-700 shadow-lg rounded-xl p-6 w-[60%]">
            <h2 className="text-lg font-semibold mb-1">Customize my space</h2>
            <p className="text-gray-600 text-sm mb-3">
              This is your space, you can add whatever you want. Write about
              your favorite book, or anything you like.
            </p>

            <textarea
              className="w-full h-24 rounded-md p-2 text-gray-700 focus:outline-none"
              placeholder="Type your story ...."
            ></textarea>

            <div className="mt-20 flex flex-row space-x-5">
              <h3 className="text-md font-semibold mt-2">Record your audio</h3>
              <button className="flex items-center justify-center w-12 h-12 bg-amber-600 text-white rounded-full shadow-md hover:bg-orange-500">
                <FaMicrophone />
              </button>
            </div>

            <button className="w-full py-2 mt-48 border border-gray-500 rounded-md hover:bg-gray-200">
              Save
            </button>
          </div>
        );

      case 6:
        return (
          <div className="bg-white border border-gray-700 shadow-lg rounded-xl p-6 w-[60%] text-center">
            <h2 className="text-2xl font-semibold text-gray-700">
              Your Final ID Card
            </h2>
            <p className="text-sm text-gray-500 mt-2">
              Congratulations! You have completed your Future ID.
            </p>
            <button
              className="w-full py-2 mt-4 border border-gray-500 rounded-md hover:bg-gray-200"
              onClick={() => navigate("/final-id-card")}
            >
              View My ID Card
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="container mx-auto max-h-screen w-full p-10 flex flex-row justify-center items-center gap-20">
        {/* Left Section - Navigation */}
        <div className="w-[50%] text-start">
          <ul className="w-96 font-semibold mt-16 text-md mx-auto">
            <h2 className="text-3xl font-bold text-gray-700 mb-16">
              My Future ID
            </h2>

            {sections.map((section, index) => (
              <li
                key={index}
                className={`py-3 px-4 mb-2 cursor-pointer rounded-lg text-gray-600 transition-all ${
                  index === currentSection
                    ? "bg-orange-400 text-white"
                    : "hover:bg-gray-200"
                }`}
                onClick={() => setCurrentSection(index)}
              >
                {section}
              </li>
            ))}
            <h2 className="text-sm mt-32 p-4 font-bold underline text-gray-700">
              Back to Trail
            </h2>
          </ul>
        </div>

        {/* Right Section - Dynamic Form */}
        <div className="w-[50%] flex justify-center items-center relative mt-16">
          {renderSection()}
        </div>
      </div>
    </div>
  );
};

export default IdCardForm;
